/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Icsrm_Diverse12Inputs */

const en__field_enum_icsrm_diverse12 = /** @type {(inputs: _Field_Enum_Icsrm_Diverse12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`diverse`)
};

const de__field_enum_icsrm_diverse12 = /** @type {(inputs: _Field_Enum_Icsrm_Diverse12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`divers`)
};

/**
* | output |
* | --- |
* | "diverse" |
*
* @param {_Field_Enum_Icsrm_Diverse12Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_icsrm_diverse12 = /** @type {((inputs?: _Field_Enum_Icsrm_Diverse12Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Icsrm_Diverse12Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_icsrm_diverse12(inputs)
	return de__field_enum_icsrm_diverse12(inputs)
});
export { _field_enum_icsrm_diverse12 as "_field_enum_ICSRM_DIVERSE" }